<template>
  <v-app>
    <w-head style="z-index: 6" />
    <w-sets style="z-index: 5" />

    <v-main class="divder bg_color" :style="`background:url(${require('@/assets/background.png')}) fixed`" style="min-width: 1366px">
      <w-tabs style="position: sticky; top: 64px; z-index: 3" />
      <keep-alive>
        <router-view />
      </keep-alive>
    </v-main>

    <v-footer color="primary" class="d-md-none d-flex align-start" padless fixed>
      <v-toolbar class="v-bottom-black-bar" color="transparent" flat dark>
        <v-toolbar-items>
          <v-btn text>
            <v-icon>mdi-chevron-up</v-icon>
          </v-btn>
          <v-btn text>
            <v-icon>mdi-star</v-icon>
          </v-btn>
        </v-toolbar-items>
        <v-btn color="secondary" fab large absolute top right v-ripple="{ center: true }">
          <v-icon>mdi-reply</v-icon>
        </v-btn>
      </v-toolbar>
    </v-footer>
    <!-- <v-footer class="d-none d-md-flex caption" padless style="z-index: 6">
      <v-col cols="12" md="12" class="pa-0"><v-divider></v-divider></v-col>
      <v-col cols="12" md="6" class="grey--text"> {{ $vtk.env.VUE_APP_FOOT }} </v-col>
      <v-col cols="12" md="6" class="grey--text text-right"> 版本：1.0.0</v-col>
    </v-footer> -->
    <wtk-message><!--弹出消息区域--></wtk-message>
  </v-app>
</template>

<script>
import wHead from "@/views/admin/_head";
import wTabs from "@/views/admin/_tabs";
import wSets from "@/views/admin/_sets";

export default {
  name: "UamsIndex",
  components: { wHead, wTabs, wSets },
  data: () => ({ }),
  methods: {},
};
</script>
<style>
.bg_color {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
</style>